export const accommodationRoomtypes = {
  ROOMTYPES_DESCRIPTION_TOGGLED: 'accommodationroomtypes.description',
  ROOMTYPES_SELECTOR_TOGGLED: 'accommodationroomtypes.selector',
  ROOMTYPES_MODAL_OPENED: 'accommodationroomtypes.modal',
  ROOMTYPES_MODAL_SEE_PRICES: 'accommodationroomtypes.modalseeprices',
  ROOMTYPES_SEE_PRICES: 'accommodationroomtypes.seeprices'
}
